module.exports = __webpack_public_path__ + "static/media/Illus-Congrats.64c75a18.png";